import { student_status_groups, tick_status_groups } from '../pages/types';
import type { Row } from 'react-table';

export const studentStatusSort = (rowA: Row, rowB: Row, columnId: string, desc?: boolean): number => {
  return student_status_groups.indexOf(rowA.values[columnId]) > student_status_groups.indexOf(rowB.values[columnId]) ? 1 : -1;
};

export const greenTickSort = (rowA: Row, rowB: Row): number => tick_status_groups.indexOf(rowA.values.green_tick) - tick_status_groups.indexOf(rowB.values.green_tick);
